import * as React from 'react';
import Text from '../../../shared/Text';
import { Box, Typography } from '@mui/material';
import { createElementsFromText } from 'html-text-to-react';

const LoginStepTotpStorageNodeWarning: React.FC = () => {
  const bodyText = Text.get('login_totp_storage_node_warning_description');
  const bodyElem = createElementsFromText(bodyText);

  const linkUrl = 'https://www.code42.com/r/support/contact-support';
  const linkText = Text.get('login_totp_storage_node_warning_more_info', { url: linkUrl });
  const linkElem = createElementsFromText(linkText);

  return (
    <Box data-test="login-step-totp-sn-warning" m="auto" mt={2} width="70%">
      <Typography gutterBottom>{bodyElem}</Typography>
      <Typography>{linkElem}</Typography>
    </Box>
  );
};

export default LoginStepTotpStorageNodeWarning;
